import { Alert, AlertTitle } from "@mui/material";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useState } from "react";

/**
 * A persistent banner that displays across the entire app.
 * The banner will remain visible until the feature flag is updated.
 * It can be dismissed by the user if showCloseButton is enabled in the feature flag.
 */
export function OutageBanner() {
  const [isDismissed, setIsDismissed] = useState(false);
  const bannerConfig = useCbhFlag(CbhFeatureFlag.DISPLAY_INCIDENT_BANNER, {
    defaultValue: {
      message: "",
      title: "",
      showCloseButton: false,
    },
  });

  if (!bannerConfig.message || isDismissed) {
    return null;
  }

  return (
    <Alert
      severity="error"
      sx={{
        position: "fixed",
        top: "env(safe-area-inset-top)",
        left: 0,
        right: 0,
        zIndex: 9999,
        borderRadius: 0,
      }}
      variant="filled"
      // Show close button only if showCloseButton is true
      onClose={
        bannerConfig.showCloseButton
          ? () => {
              setIsDismissed(true);
            }
          : undefined
      }
    >
      <AlertTitle sx={(theme) => ({ color: theme.palette.common.white })}>
        {bannerConfig.title}
      </AlertTitle>
      {bannerConfig.message}
    </Alert>
  );
}
